import { Link } from "react-router-dom";
import { InstagramLogo, Phone, WhatsappLogo, MapPin, Clock } from "@phosphor-icons/react";
import { CONTACT, IMAGES, SEO_LINKS, NAV } from "@/data/site";
import { MATRIZ, ALL_UNITS } from "@/data/filiais";
import { whatsappUrl, telUrl } from "@/lib/contact";

export default function Footer() {
  return (
    <footer className="relative border-t border-white/10 bg-brand-obsidian" data-testid="site-footer">
      {/* SEO regions block */}
      <section className="border-b border-white/10 bg-brand-coal px-5 py-16 md:px-8">
        <div className="mx-auto max-w-7xl">
          <h2 className="font-heading text-xl font-bold uppercase tracking-tight text-white md:text-2xl">
            Regiões Atendidas pela Auto Socorro Pimenta
          </h2>
          <p className="mt-4 max-w-4xl text-sm leading-relaxed text-white/60">
            A Auto Socorro Pimenta oferece serviços de guincho leve e pesado, auto socorro 24 horas,
            assistência rodoviária, reboque de veículos, reboque de caminhões e transporte de máquinas em
            Rondônia e Mato Grosso. Atendemos Pimenta Bueno, Vilhena, Cacoal, Ji-Paraná, Jaru, Ouro
            Preto do Oeste, São Miguel do Guaporé, São Francisco do Guaporé, Rolim de Moura, Colorado
            do Oeste, Comodoro (MT), Campos de Júlio (MT), Sapezal (MT) e cidades vizinhas, garantindo
            atendimento rápido, seguro e eficiente.
          </p>
          <div className="mt-8">
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-brand-red">Principais buscas</p>
            <div className="mt-4 flex flex-wrap gap-2">
              {SEO_LINKS.map((k) => (
                <span
                  key={k}
                  className="rounded-sm border border-white/10 bg-brand-obsidian px-3 py-1.5 text-xs text-white/50 transition-colors duration-200 hover:border-brand-red hover:text-white"
                >
                  {k}
                </span>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Main footer */}
      <div className="mx-auto max-w-7xl px-5 py-16 md:px-8">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <img src={IMAGES.logo} alt="Auto Socorro Pimenta" className="h-12 w-auto" />
            <p className="mt-5 text-sm leading-relaxed text-white/50">
              Há mais de {CONTACT.years} anos oferecendo guincho 24 horas, assistência rodoviária e
              transporte de máquinas em Rondônia e Mato Grosso.
            </p>
            <a
              href={CONTACT.instagram}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram"
              className="mt-6 inline-flex items-center gap-2 text-sm text-white/60 transition-colors hover:text-brand-red"
            >
              <InstagramLogo weight="fill" className="h-5 w-5" />
              {CONTACT.instagramHandle}
            </a>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold uppercase tracking-[0.2em] text-white">Navegação</h3>
            <ul className="mt-5 space-y-3 text-sm">
              {NAV.filter((n) => !n.children).map((n) => (
                <li key={n.path}>
                  <Link to={n.path} className="text-white/50 transition-colors hover:text-white">{n.label}</Link>
                </li>
              ))}
              <li><Link to={MATRIZ.path} className="text-white/50 transition-colors hover:text-white">Matriz — {MATRIZ.city}</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold uppercase tracking-[0.2em] text-white">Unidades</h3>
            <ul className="mt-5 grid grid-cols-2 gap-x-4 gap-y-3 text-sm">
              {ALL_UNITS.filter((u) => u.kind !== "Matriz").map((u) => (
                <li key={u.slug}>
                  <Link to={u.path} className="text-white/50 transition-colors hover:text-white">{u.city} <span className="text-white/25">{u.uf}</span></Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold uppercase tracking-[0.2em] text-white">Contato 24h</h3>
            <ul className="mt-5 space-y-4 text-sm">
              <li>
                <a href={telUrl()} className="flex items-center gap-3 text-white/60 transition-colors hover:text-white">
                  <Phone weight="fill" className="h-4 w-4 text-brand-red" /> {CONTACT.phoneDisplay}
                </a>
              </li>
              <li>
                <a href={whatsappUrl()} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-white/60 transition-colors hover:text-white">
                  <WhatsappLogo weight="fill" className="h-4 w-4 text-brand-red" /> {CONTACT.whatsappDisplay}
                </a>
              </li>
              <li className="flex items-center gap-3 text-white/60">
                <MapPin weight="fill" className="h-4 w-4 text-brand-red" /> Rondônia e Mato Grosso
              </li>
              <li className="flex items-center gap-3 text-white/60">
                <Clock weight="fill" className="h-4 w-4 text-brand-red" /> Aberto 24 horas, todos os dias
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-8 text-xs text-white/40 md:flex-row md:items-center">
          <p>© {new Date().getFullYear()} Auto Socorro Pimenta. Todos os direitos reservados.</p>
          <p className="font-mono uppercase tracking-widest">Guincho 24 Horas · RO & MT</p>
        </div>
      </div>
    </footer>
  );
}
